'use client'

import Button from '@eversports/klimt-primitives/Button'
import { useTranslations } from 'next-intl'

import { FILTER_DATA, FILTER_OPTIONS_TRANSLATION_MAPPING } from '../Filters.constants'
import { type FILTER_OPTIONS, FILTER_TYPE } from '../Filters.types'

interface Props {
  filterType: FILTER_TYPE
  activeFilters: Array<string>
  resetFilter: (type: FILTER_TYPE) => () => void
  updateFilters: ({
    type,
    value,
    maxOptionsCount,
  }: {
    type: FILTER_TYPE
    value: string
    maxOptionsCount: number
  }) => () => void
}

const FilterSheetGroup = ({ filterType, activeFilters, updateFilters, resetFilter }: Props) => {
  const t = useTranslations('discover-sport-city')

  const { options, mobileHeaderTranslationKey } = FILTER_DATA[filterType]
  const maxOptionsCount = Object.keys(options).length

  return (
    <div>
      <h3 className="mb-1 text-base text-text-primary">{t(mobileHeaderTranslationKey)}</h3>
      <div className="flex flex-wrap gap-2">
        <Button
          size="sm"
          variant={!activeFilters.length ? 'tertiary-selected' : 'tertiary'}
          onClick={resetFilter(filterType)}
        >
          {t('all-filters')}
        </Button>
        {options.map((option) => {
          const selected = activeFilters.includes(option)
          return (
            <Button
              size="sm"
              key={option}
              variant={selected ? 'tertiary-selected' : 'tertiary'}
              onClick={updateFilters({ type: filterType, value: option, maxOptionsCount })}
            >
              {t(FILTER_OPTIONS_TRANSLATION_MAPPING[option as FILTER_OPTIONS])}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default FilterSheetGroup
